import React from "react";

/**
 * @component ExpensePlusIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ExpensePlusIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ExpensePlusIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="ExpensePlusIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M20 21a2 2 0 001.994-1.85L22 19v-7h-2v7H4V5h8V3H4a2 2 0 00-1.995 1.85L2 5v14c0 1.06.81 1.919 1.85 1.994L4 21h16z"
        clipRule="evenodd"
      />
      <path d="M11 8V7H9v1H8l-.117.007A1 1 0 007 9v3l.007.117A1 1 0 008 13h3v1H7v2h2v1h2v-1h1l.117-.007A1 1 0 0013 15v-3l-.007-.117A1 1 0 0012 11H9v-1h4V8h-2zm8.057-3.943c.17.61.53 1.282 1.096 1.848A4.298 4.298 0 0022 7.001c-.61.17-1.281.529-1.847 1.095a4.296 4.296 0 00-1.095 1.846 4.3 4.3 0 00-1.096-1.846A4.299 4.299 0 0016.114 7a4.296 4.296 0 001.848-1.095 4.297 4.297 0 001.095-1.848zm-2.943-2.412c.079.28.244.59.505.851.26.26.57.426.85.504a1.98 1.98 0 00-.85.505c-.26.26-.426.57-.505.85a1.98 1.98 0 00-.504-.85A1.98 1.98 0 0014.76 3c.28-.078.59-.243.85-.504.26-.26.426-.57.504-.85z" />
    </svg>
  )
);
ExpensePlusIcon.displayName = "ExpensePlusIcon";
export default ExpensePlusIcon;
